/**
 * The checker's rule sets, dated YYYY-MM so they order as strings. An automation
 * is checked under the one it records, so a later rule can't stop it publishing.
 */
export const RULES_VERSIONS: readonly string[] = ["2026-11"];

export const FIRST_RULES_VERSION = "2026-11";

export const CURRENT_RULES_VERSION: string =
  RULES_VERSIONS[RULES_VERSIONS.length - 1] ?? FIRST_RULES_VERSION;

export function isKnownRulesVersion(version: string): boolean {
  return RULES_VERSIONS.includes(version);
}

/** Automations saved before rules versions existed are on the first. */
export function rulesVersionOf(automation: { rulesVersion?: string }): string {
  return automation.rulesVersion ?? FIRST_RULES_VERSION;
}
